<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <el-col>
                <span class="cs-title">价格管理</span>
                <el-tabs v-model="activeTab" type="card" @tab-click="onTabClick">

                  <el-tab-pane v-if="USERMANAGER.isAdmin || USERMANAGER.isStudyAbroad" name="sapPrice">
                    <span slot="label">真留计划</span>
                    <el-row class="grid-content">
                      <el-col>
                        <sapPrice ref="sapPrice" :readonly="optionsForComponents.sapPrice.isReadonly" @valueChange="onSapPriceValueChange"></sapPrice>
                      </el-col>
                    </el-row>
                  </el-tab-pane>

                  <template v-if="USERMANAGER.isAdmin || !USERMANAGER.isStudyAbroad">
                    <el-tab-pane name="trainingPrice">
                      <span slot="label">职业培训</span>
                      <el-row class="grid-content">
                        <el-col>
                          <trainingPrice :isActive="activeTab == 'trainingPrice'" :courseType="GLOBAL.courseType.vocationalTraining"
                            :readonly="optionsForComponents.trainingPrice.isReadonly"></trainingPrice>
                        </el-col>
                      </el-row>
                    </el-tab-pane>
                    <template v-if="!USERMANAGER.isVocationalTrainingManager">
                      <el-tab-pane name="englishTrainingPrice">
                        <span slot="label">应试英语</span>
                        <el-row class="grid-content">
                          <el-col>
                            <trainingPrice :isActive="activeTab == 'englishTrainingPrice'" :courseType="GLOBAL.courseType.english"
                              :readonly="optionsForComponents.englishTrainingPrice.isReadonly">
                            </trainingPrice>
                          </el-col>
                        </el-row>
                      </el-tab-pane>
                      <el-tab-pane name="newStudentGuidePrice">
                        <span slot="label">新生引流</span>
                        <el-row class="grid-content">
                          <el-col>
                            <trainingPrice :isActive="activeTab == 'newStudentGuidePrice'" :courseType="GLOBAL.courseType.newStudentGuide"
                              :readonly="optionsForComponents.newStudentGuidePrice.isReadonly"></trainingPrice>
                          </el-col>
                        </el-row>
                      </el-tab-pane>
                      <el-tab-pane name="courseUnitPrice">
                        <span slot="label">退款余额</span>
                        <el-row class="grid-content">
                          <el-col>
                            <courseUnitPrice :isActive="activeTab == 'courseUnitPrice'" :options="optionsForComponents.courseUnitPrice"></courseUnitPrice>
                          </el-col>
                        </el-row>
                      </el-tab-pane>
                      <el-tab-pane name="videoUnitPrice">
                        <span slot="label">看视频价格</span>
                        <el-row class="grid-content">
                          <el-col>
                            <videoUnitPrice :isActive="activeTab == 'videoUnitPrice'" :options="optionsForComponents.videoUnitPrice"></videoUnitPrice>
                          </el-col>
                        </el-row>
                      </el-tab-pane>
                      <el-tab-pane name="videoWatchingDuration">
                        <span slot="label">视频观看时长</span>
                        <el-row class="grid-content">
                          <el-col>
                            <videoWatchingDuration :isActive="activeTab == 'videoWatchingDuration'" :options="optionsForComponents.videoWatchingDuration">
                            </videoWatchingDuration>
                          </el-col>
                        </el-row>
                      </el-tab-pane>
                      <el-tab-pane name="memberCardPrice">
                        <span slot="label">会员卡</span>
                        <el-row class="grid-content">
                          <el-col>
                            <memberCardPrice :isActive="activeTab == 'memberCardPrice'" :options="optionsForComponents.memberCardPrice"></memberCardPrice>
                          </el-col>
                        </el-row>
                      </el-tab-pane>
                      <el-tab-pane name="paymentCommissionRate">
                        <span slot="label">付款手续费</span>
                        <el-row class="grid-content">
                          <el-col>
                            <paymentCommissionRate :isActive="activeTab == 'paymentCommissionRate'" :options="optionsForComponents.paymentCommissionRate">
                            </paymentCommissionRate>
                          </el-col>
                        </el-row>
                      </el-tab-pane>
                      <el-tab-pane name="advanceEnrollmentPrice">
                        <span slot="label">提前占位</span>
                        <el-row class="grid-content">
                          <el-col>
                            <advanceEnrollmentPrice :isActive="activeTab == 'advanceEnrollmentPrice'" :options="optionsForComponents.advanceEnrollmentPrice">
                            </advanceEnrollmentPrice>
                          </el-col>
                        </el-row>
                      </el-tab-pane>
                      <el-tab-pane name="academicPlanningPrice">
                        <span slot="label">学业规划</span>
                        <el-row class="grid-content">
                          <el-col>
                            <academicPlanningPrice :isActive="activeTab == 'academicPlanningPrice'" :options="optionsForComponents.academicPlanningPrice">
                            </academicPlanningPrice>
                          </el-col>
                        </el-row>
                      </el-tab-pane>
                      <el-tab-pane name="airportPickUpPrice">
                        <span slot="label">接机服务</span>
                        <el-row class="grid-content">
                          <el-col>
                            <airportPickUpPrice :isActive="activeTab == 'airportPickUpPrice'" :options="optionsForComponents.airportPickUpPrice">
                            </airportPickUpPrice>
                          </el-col>
                        </el-row>
                      </el-tab-pane>
                      <el-tab-pane name="autoEnrollCoursePrice">
                        <span slot="label">刷课</span>
                        <el-row class="grid-content">
                          <el-col>
                            <autoEnrollCoursePrice :isActive="activeTab == 'autoEnrollCoursePrice'" :options="optionsForComponents.autoEnrollCoursePrice">
                            </autoEnrollCoursePrice>
                          </el-col>
                        </el-row>
                      </el-tab-pane>
                      <el-tab-pane name="vipCoursePrice">
                        <span slot="label">VIP</span>
                        <el-row class="grid-content">
                          <el-col>
                            <vipCoursePrice :isActive="activeTab == 'vipCoursePrice'" :options="optionsForComponents.vipCoursePrice"></vipCoursePrice>
                          </el-col>
                        </el-row>
                      </el-tab-pane>
                      <el-tab-pane v-for="item in courseCategories" :key="item.Key" :name="`courceCategory:${item.Key}`">
                        <span slot="label">{{item.Value}}</span>
                        <el-row class="grid-content">
                          <el-col>
                            <courseCategoryOptionEdit :isReview="true" :isActive="activeTab == `courceCategory:${item.Key}`" :categoryId="item.Key"
                              :options="optionsForComponents.courseCategoryOptionEdit">
                            </courseCategoryOptionEdit>
                          </el-col>
                        </el-row>
                      </el-tab-pane>
                      <el-tab-pane name="giftBalanceSetting">
                        <span slot="label">余额充值优惠</span>
                        <el-row class="grid-content">
                          <el-col>
                            <giftBalance :isActive="activeTab == 'giftBalanceSetting'" :options="optionsForComponents.giftBalance">
                            </giftBalance>
                          </el-col>
                        </el-row>
                      </el-tab-pane>
                      <el-tab-pane name="campusTaxRateSetting">
                        <span slot="label">校区税率</span>
                        <el-row class="grid-content">
                          <el-col>
                            <campusTaxRate :isActive="activeTab == 'campusTaxRateSetting'" :options="optionsForComponents.campusTaxRate"></campusTaxRate>
                          </el-col>
                        </el-row>
                      </el-tab-pane>
                    </template>
                  </template>

                </el-tabs>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
/* elementui 的tabs组件出现蓝色边框问题 */

.el-tabs__item:focus.is-active.is-focus:not(:active) {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
</style>

<script>
import navigator from "../../components/navigator";
import courseUnitPrice from "../../components/priceManagement/courseUnitPrice";
import videoUnitPrice from "../../components/priceManagement/videoUnitPrice";
import videoWatchingDuration from "../../components/priceManagement/videoWatchingDuration";
import memberCardPrice from "../../components/priceManagement/memberCardPrice";
import paymentCommissionRate from "../../components/priceManagement/paymentCommissionRate";
import advanceEnrollmentPrice from "../../components/priceManagement/advanceEnrollmentPrice";
import academicPlanningPrice from "../../components/priceManagement/academicPlanningPrice";
import airportPickUpPrice from "../../components/priceManagement/airportPickUpPrice";
import autoEnrollCoursePrice from "../../components/priceManagement/autoEnrollCoursePrice";
import courseCategoryOptionEdit from "../../components/priceManagement/courseCategoryOptionEdit";
import trainingPrice from "../../components/priceManagement/trainingPrice";
import giftBalance from "../../components/priceManagement/giftBalance";
import campusTaxRate from "../../components/priceManagement/campusTaxRate";
import sapPrice from "@/components/studyAbroad/priceManagement/sapPrice";
import vipCoursePrice from "@/components/priceManagement/vipCoursePrice";

import {
  getUniversities,
  getCourseCategoryList,
} from "@/service/common.service";

export default {
  data() {
    return {
      activeTab:
        this.USERMANAGER.isStudyAbroad || this.USERMANAGER.isAdmin
          ? "sapPrice"
          : "trainingPrice",
      courseCategories: [],
      optionsForComponents: {
        courseUnitPrice: {
          isReadonly: false,
        },
        videoUnitPrice: {
          isReadonly: false,
        },
        videoWatchingDuration: {
          isReadonly: false,
        },
        memberCardPrice: {
          isReadonly: false,
        },
        paymentCommissionRate: {
          isReadonly: false,
        },
        advanceEnrollmentPrice: {
          isReadonly: false,
        },
        academicPlanningPrice: {
          isReadonly: false,
        },
        airportPickUpPrice: {
          isReadonly: false,
        },
        autoEnrollCoursePrice:{
          isReadonly: false,
        },
        courseCategoryOptionEdit: {
          isReadonly: false,
        },
        trainingPrice: {
          isReadonly: false,
        },
        englishTrainingPrice: {
          isReadonly: false,
        },
        newStudentGuidePrice: {
          isReadonly: false,
        },
        giftBalance: {
          isReadonly: false,
        },
        campusTaxRate: {
          isReadonly: false,
        },
        sapPrice: {
          isReadonly: false,
        },
        vipCoursePrice: {
          isReadonly: false,
        },
      },
      hasSapPriceValueChange: false,
    };
  },
  components: {
    navigator,
    courseUnitPrice,
    videoUnitPrice,
    videoWatchingDuration,
    memberCardPrice,
    paymentCommissionRate,
    advanceEnrollmentPrice,
    academicPlanningPrice,
    airportPickUpPrice,
    autoEnrollCoursePrice,
    courseCategoryOptionEdit,
    trainingPrice,
    giftBalance,
    campusTaxRate,
    sapPrice,
    vipCoursePrice,
  },
  computed: {},
  created() {
    if (this.USERMANAGER.isStudyAbroad || this.USERMANAGER.isAdmin) {
      this.activeTab = "sapPrice";
    } else {
      this.activeTab = "trainingPrice";
    }

    this.init();
  },
  methods: {
    init() {
      this.reloadOptionsForAllComponents();
      this.loadCourseCategoriesFromServer();
    },
    async loadCourseCategoriesFromServer() {
      let courseType = this.GLOBAL.courseType.university;
      let result = await getCourseCategoryList(courseType, true);
    
      if (!!result && result.success) {
        //排除Vip
        this.courseCategories = result.data.filter((i) => i.Key != 2);
      } else {
        this.courseCategories = [];
      }
    },
    reloadOptionsForAllComponents() {
      this.reloadOptionsForCourseUnitPrice();
      this.reloadOptionsForVideoUnitPrice();
      this.reloadOptionsForVideoWatchingDuration();
      this.reloadOptionsForMemberCardPrice();
      this.reloadOptionsForPaymentCommissionRate();
      this.reloadOptionsForAdvanceEnrollmentPrice();
      this.reloadOptionsForAcademicPlanningPrice();
      this.reloadOptionsForAirportPickUpPrice();
      this.reloadOptionsForAutoEnrollCoursePrice();
      this.reloadOptionsForCourseCategoryOptionEdit();
      this.reloadOptionsForTrainingPrice();
      this.reloadOptionsForEnglishTrainingPrice();
      this.reloadOptionsForNewStudentGuidePrice();
      this.reloadOptionsForEnglishGiftBalance();
      this.reloadOptionsForCampusTaxRate();
      this.reloadOptionsForSAPPrice();
      this.reloadOptionsForVipCoursePrice();
    },
    reloadOptionsForCourseUnitPrice() {
      let newOptions = {
        isReadonly: false,
      };

      newOptions.isReadonly = !this.USERMANAGER.isAdmin;

      this.optionsForComponents.courseUnitPrice = newOptions;
    },
    reloadOptionsForVideoUnitPrice() {
      let newOptions = {
        isReadonly: false,
      };

      newOptions.isReadonly = !this.USERMANAGER.isAdmin;

      this.optionsForComponents.videoUnitPrice = newOptions;
    },
    reloadOptionsForVideoWatchingDuration() {
      let newOptions = {
        isReadonly: false,
      };

      newOptions.isReadonly = !this.USERMANAGER.isAdmin;

      this.optionsForComponents.videoWatchingDuration = newOptions;
    },
    reloadOptionsForMemberCardPrice() {
      let newOptions = {
        isReadonly: false,
      };

      newOptions.isReadonly = !this.USERMANAGER.isAdmin;

      this.optionsForComponents.memberCardPrice = newOptions;
    },
    reloadOptionsForPaymentCommissionRate() {
      let newOptions = {
        isReadonly: false,
      };

      newOptions.isReadonly = !this.USERMANAGER.isAdmin;

      this.optionsForComponents.paymentCommissionRate = newOptions;
    },
    reloadOptionsForAdvanceEnrollmentPrice() {
      let newOptions = {
        isReadonly: false,
      };

      newOptions.isReadonly = !this.USERMANAGER.isAdmin;

      this.optionsForComponents.advanceEnrollmentPrice = newOptions;
    },
    reloadOptionsForAcademicPlanningPrice() {
      let newOptions = {
        isReadonly: false,
      };

      newOptions.isReadonly = !this.USERMANAGER.isAdmin;

      this.optionsForComponents.academicPlanningPrice = newOptions;
    },
    reloadOptionsForAirportPickUpPrice() {
      let newOptions = {
        isReadonly: false,
      };

      newOptions.isReadonly = !this.USERMANAGER.isAdmin;

      this.optionsForComponents.airportPickUpPrice = newOptions;
    },
    reloadOptionsForAutoEnrollCoursePrice() {
      let newOptions = {
        isReadonly: false,
      };

      newOptions.isReadonly = !this.USERMANAGER.isAdmin;

      this.optionsForComponents.autoEnrollCoursePrice = newOptions;
    },
    reloadOptionsForCourseCategoryOptionEdit() {
      let newOptions = {
        isReadonly: false,
      };

      newOptions.isReadonly = !this.USERMANAGER.isAdmin;

      this.optionsForComponents.courseCategoryOptionEdit = newOptions;
    },
    reloadOptionsForTrainingPrice() {
      let newOptions = {
        isReadonly: false,
      };

      newOptions.isReadonly =
        !this.USERMANAGER.isAdmin &&
        !this.USERMANAGER.isVocationalTrainingManager;

      this.optionsForComponents.trainingPrice = newOptions;
    },
    reloadOptionsForEnglishTrainingPrice() {
      let newOptions = {
        isReadonly: false,
      };

      newOptions.isReadonly = !this.USERMANAGER.isAdmin;

      this.optionsForComponents.englishTrainingPrice = newOptions;
    },
    reloadOptionsForNewStudentGuidePrice() {
      let newOptions = {
        isReadonly: false,
      };

      newOptions.isReadonly = !this.USERMANAGER.isAdmin;

      this.optionsForComponents.newStudentGuidePrice = newOptions;
    },
    reloadOptionsForEnglishGiftBalance() {
      let newOptions = {
        isReadonly: false,
      };

      newOptions.isReadonly = !this.USERMANAGER.isAdmin;

      this.optionsForComponents.giftBalance = newOptions;
    },
    reloadOptionsForCampusTaxRate() {
      let newOptions = {
        isReadonly: false,
      };

      newOptions.isReadonly = !this.USERMANAGER.isAdmin;

      this.optionsForComponents.campusTaxRate = newOptions;
    },
    reloadOptionsForSAPPrice() {
      let newOptions = {
        isReadonly: false,
      };

      newOptions.isReadonly =
        !this.USERMANAGER.isSAFinancialManager && !this.USERMANAGER.isAdmin;

      this.optionsForComponents.sapPrice = newOptions;
    },
    reloadOptionsForVipCoursePrice() {
      let newOptions = {
        isReadonly: false,
      };

      newOptions.isReadonly = !this.USERMANAGER.isAdmin;

      this.optionsForComponents.vipCoursePrice = newOptions;
    },
    onTabClick(tab) {},
    onSapPriceValueChange(isChanged) {
      this.hasSapPriceValueChange = isChanged;
    },
  },
  watch: {},
  async beforeRouteLeave(to, from, next) {
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.

    if (this.hasSapPriceValueChange) {
      this.$confirm("真留价格设置已修改，是否保存?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let result = await this.$refs.sapPrice.saveChanges();
          if (result && result.success) {
            this.hasSapPriceValueChange = false;
            next();
          }
        })
        .catch(() => {
          next();
        });
    } else {
      next();
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/page/admin/priceManagement.vue